import React, { useRef, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { ApiHook } from "../../hooks/apiHook";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { PhoneInput } from "react-international-phone";

import SignaturePad from "signature_pad";

function AddressModal({ show, setShow, setSignature, signature ,formValues,register,setValue ,handleUpload}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const {
    handleSubmit,
    control,
    reset,
    setError,
    formState: { errors },
  } = useForm();
  const canvasRef = useRef(null);
  const signaturePadRef = useRef(null);

  const addAddressMutation = ApiHook.CallAddAddress();

  const onSubmit = (data) => {
    if (data.phoneNumber.length <= 6) {
      setError("phoneNumber", {
        type: "manual",
        message: t("min_length"),
      });
      return;
    }

    addAddressMutation.mutate(data, {
      onSuccess: (res) => {
        if (res?.status) {
          setShow(false);
          reset();
          queryClient.invalidateQueries({ queryKey: ["get-address"] });
          toast.success(res?.message);
        } else {
          toast.error(res?.data?.description);
        }
      },
    });
  };

  //   useEffect(() => {
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext("2d");

  //   if (formValues?.signature) {
  //     const img = new Image();
  //     img.src = formValues?.signature;
  //     img.onload = () => {
  //       ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear previous drawing
  //       ctx.drawImage(img, 0, 0, canvas.width, canvas.height); // Draw the signature
  //     };
  //   }
  // }, [formValues?.signature]);

  useEffect(() => {
    if (canvasRef.current) {
      signaturePadRef.current = new SignaturePad(canvasRef.current, {
        backgroundColor: "rgb(255, 255, 255)", // White background
        penColor: "rgb(0, 0, 0)", // Black pen color
      });
    }

    // Cleanup on unmount
    return () => {
      if (signaturePadRef.current) {
        signaturePadRef.current.off(); // Remove event listeners
      }
    };
  }, [show]);

  const handleClose = () => {
    setShow(false);
    reset();
  };
  const clearSignature = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
    setSignature(null);
  };

  const addSignature = () => {
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const image = signaturePadRef.current.toDataURL("image/png");
      setSignature(image); // Get signature as PNG
      setValue("signature",image)
    }
    setShow(false);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Add digital signature")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <canvas
              ref={canvasRef}
              width={450}
              height={200}
              style={{ border: "1px solid black" }}
            />
          </div>
          <h3>OR</h3>

      {/* File Upload for Signature */}
      <input type="file" accept="image/*" onChange={handleUpload} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit" onClick={addSignature}>
            {t("Add Signature")}
          </Button>
          <Button variant="secondary" onClick={clearSignature}>
            {t("Clear signature")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddressModal;
